import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

export const obtenerNotificaciones = async () => {
  const response = await axios.get(`${API_URL}/notificaciones`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const conteoNotificaciones = async () => {
  const response = await axios.get(`${API_URL}/notificaciones/count`, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const marcarLeida = async (id) => {
  const response = await axios.put(`${API_URL}/notificaciones/${id}/leer`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};

export const marcarTodasLeidas = async () => {
  const response = await axios.put(`${API_URL}/notificaciones/leer-todas`, {}, {
    headers: getAuthHeaders()
  });
  return response.data;
};
